"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportingContext = void 0;
const react_1 = require("react");
exports.ReportingContext = (0, react_1.createContext)(undefined);
//# sourceMappingURL=reporting-context.js.map